export enum UpgradeState {
    verification,
    finish
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/state/UpgradeState.ts